import type { YaasStatsResponse } from "@solomon-apps/shared";
import { API_URLS, DEFAULT_QUERY_OPTIONS, fetchJson } from "@solomon-apps/shared";
import { queryOptions } from "@tanstack/react-query";

export async function fetchYaasStats(signal?: AbortSignal): Promise<YaasStatsResponse> {
    return fetchJson<YaasStatsResponse>(`${API_URLS.YAAS}/api/yaas/stats`, signal);
}

/**
 * The one definition of the GET /api/yaas/stats query. Every reader
 * passes it to `useQuery` and picks the fields it needs, so they share
 * one cache entry and cannot drift on key or polling options.
 */
export const platformStatsQuery = queryOptions<YaasStatsResponse, Error>({
    queryKey: ["yaas", "stats"],
    queryFn: ({ signal }) => fetchYaasStats(signal),
    ...DEFAULT_QUERY_OPTIONS
});
